var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17px",
  height: "17px",
  viewBox: "0 0 17 17",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "A99DA7F0-980F-473D-B8D6-9B74993B7D7A") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.490000 0 0 0 0 0.490000 0 0 0 0 0.490000 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-/-02",
  transform: "translate(-23.000000, -1387.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Event",
  transform: "translate(15.000000, 870.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ubeya-icons/outline/My-Schedule-Copy-3",
  transform: "translate(8.000000, 517.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17,0 L17,17 L0,17 L0,0 L17,0 Z",
  id: "Vector",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-1)",
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.416667, 1.416667)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.9404762,0.876984127 L2.49603175,0.876984127 C1.11751148,0.876984127 2.39667193e-15,1.9944956 2.39667193e-15,3.37301587 L2.39667193e-15,11.468254 C2.39667193e-15,12.8467742 1.11751148,13.9642857 2.49603175,13.9642857 L11.9404762,13.9642857 C13.3189965,13.9642857 14.4365079,12.8467742 14.4365079,11.468254 L14.4365079,3.37301587 C14.4365079,1.9944956 13.3189965,0.876984127 11.9404762,0.876984127 Z M2.49603175,1.82142857 L11.9404762,1.82142857 C12.7973942,1.82142857 13.4920635,2.51609787 13.4920635,3.37301587 L13.4920635,11.468254 C13.4920635,12.325172 12.7973942,13.0198413 11.9404762,13.0198413 L2.49603175,13.0198413 C1.63911374,13.0198413 0.944444444,12.325172 0.944444444,11.468254 L0.944444444,3.37301587 C0.944444444,2.51609787 1.63911374,1.82142857 2.49603175,1.82142857 Z",
  id: "Rectangle",
  fill: "#7D7D7D",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-7",
  fill: "#7D7D7D",
  fillRule: "nonzero",
  points: "13.9642857 4.25 13.9642857 5.25 0.472222222 5.25 0.472222222 4.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-3",
  fill: "#7D7D7D",
  fillRule: "nonzero",
  points: "5.04761905 0 5.04761905 3.37301587 4.04761905 3.37301587 4.04761905 0"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-5",
  fill: "#7D7D7D",
  fillRule: "nonzero",
  points: "10.4444444 0 10.4444444 3.37301587 9.44444444 3.37301587 9.44444444 0"
})))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar2);
export default ForwardRef;